//Import Currency presenter
import CurrencyPresenter from '../../../helper/ADODB/super/currency/presenter.js'
//Import AssetStatus Status
import AssetStatusPresenter from '../../../master/asset_status/presenter.js'
//Import AssetType presenter
// import AssetTypePresenter from '../../../master/asset_type/presenter.js'
//Import Vendor Presenter
import VendorPresenter from '../../../master/vendor/presenter.js'
//Import Site Presenter
// import SitePresenter from '../../../location/site/presenter.js'
//Import Location Presenter
// import LocationPresenter from '../../../location/location/presenter.js'

// import ContactPresenter from '../../../master/contact/presenter.js'

// import SiteTypePresenter from '../../../master/site_type/presenter.js'

// import SiteStatusPresenter from '../../../master/site_status/presenter.js'

/*import MessageProperties from '../../../config/message.js';*/


export default class MasterRecordHelper{
  RunRedux = null
  UserReducer = null
  AssetStatusReducer = null
  AssetTypeReducer = null
  VendorReducer = null
  // SiteReducer = null
  // LocationReducer = null
  // ContactReducer = null
  // SiteTypeReducer = null
  // SiteStatusReducer = null

  constructor(run_redux,user_reducer,asset_status_reducer,asset_type_reducer,vendor_reducer,site_reducer,location_reducer,contact_reducer,site_type,site_status){
    this.RunRedux =run_redux
    this.UserReducer =user_reducer
    this.AssetStatusReducer = asset_status_reducer
    this.AssetTypeReducer = asset_type_reducer
    this.VendorReducer = vendor_reducer
    this.SiteReducer = site_reducer
    this.LocationReducer = location_reducer
    // this.ContactReducer = contact_reducer
    // this.SiteTypeReducer = site_type
    // this.SiteStatusReducer = site_status
  }
  __GenerateMasterTableRequestParameter__(action="Read",Reducer,onsuccess,onfailed){
    // console.log("UR Token : "+this.UserReducer.token)
    return {
        data : {
          query:'',
          AuthorizationToken : this.UserReducer.token,
        },
        action : action,
        is_props_field: true,//declare if it is a master field from another model
        Reducer: Reducer,
        RunRedux : this.RunRedux,
        onfailed : this.__OnMasterTableReadFailed__,
        onsuccess : onsuccess,

    }
  }
  LoadMasterPropsField(){
    //Load Master Currencies
    CurrencyPresenter.LoadCurrencies({
      AuthorizationToken : this.UserReducer.token,
      RunRedux : this.RunRedux,
    })
    // Load Asset Status
    AssetStatusPresenter.ReadAssetStatus(
      this.__GenerateMasterTableRequestParameter__(
        "Read",
        this.AssetStatusReducer,
        this.__OnMasterTableReadFailed__,
        null
      )
    )
    // //Load Asset Type
    // AssetTypePresenter.ReadAssetType(
    //   this.__GenerateMasterTableRequestParameter__(
    //     "Read",
    //     this.AssetTypeReducer,
    //     this.__OnMasterTableReadFailed__,
    //     null
    //   )
    // )
    //Load Vendors
    VendorPresenter.ReadVendor(
      this.__GenerateMasterTableRequestParameter__(
        "Read",
        this.VendorReducer,
        this.__OnMasterTableReadFailed__,
        null
      )
    )
    //Load Site
    // SitePresenter.ReadSite(
    //   this.__GenerateMasterTableRequestParameter__(
    //     "Read",
    //     this.SiteReducer,
    //     this.__OnMasterTableReadFailed__,
    //     null
    //   )
    // )
    //Load Location
    // LocationPresenter.ReadLocation(
    //   this.__GenerateMasterTableRequestParameter__(
    //     "Read",
    //     this.LocationReducer,
    //     this.__OnMasterTableReadFailed__,
    //     null
    //   )
    // )
  }

  // LoadMasterSiteTypeField(){
  //   SiteTypePresenter.ReadSiteType(
  //     this.__GenerateMasterTableRequestParameter__(
  //       "Read",
  //       this.SiteTypeReducer,
  //       this.__OnMasterTableReadFailed__,
  //       null
  //     )
  //   )
  // }

  // LoadMasterSiteStatusField(){
  //   SiteStatusPresenter.ReadSiteStatus(
  //     this.__GenerateMasterTableRequestParameter__(
  //       "Read",
  //       this.SiteStatusReducer,
  //       this.__OnMasterTableReadFailed__,
  //       null
  //     )
  //   )
  // }

  // LoadMasterContactField(){
  //   ContactPresenter.ReadContact(
  //     this.__GenerateMasterTableRequestParameter__(
  //       "Read",
  //       this.ContactReducer,
  //       this.__OnMasterTableReadFailed__,
  //       null
  //     )
  //   )
  // }

  __OnMasterTableReadFailed__(){
    console.error("Master Table Load Error!")
  }

}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/master.js